// import apiCall from '@/utils/api-call'
// import Urls from '@/router/urls'

export default {
  setDebugMode ({ commit }, payload) {
    commit('SET_DEBUG_MODE', payload)
  },

  setDisabledUrl ({ commit }, payload) {
    commit('SET_DISABLED_URL', payload)
  },

  setFormData ({ commit }, payload) {
    commit('SET_FORM_DATA', payload)
  },

  setFinished ({ commit }, payload) {
    commit('SET_FINISHED', payload)
  },

  setSignMode ({ commit }, payload) {
    commit('SET_SIGN_MODE', payload)
  },

  setSigned ({ commit }, payload) {
    commit('SET_SIGNED', payload)
  },

  setFileError ({ commit }, payload) {
    commit('SET_FILE_ERROR', payload)
  },

  resetFormData ({ commit }) {
    commit('RESET_FORM_DATA')
  },

  setToken ({ commit }, payload) {
    commit('SET_TOKEN', payload)
  }
}
